import Axios, { AxiosResponse } from 'axios';
import { AxiosRequestConfig } from 'axios';
import store from '@/store';

const Config = (require("/public/setting") as any).Config;

const baseConfig: AxiosRequestConfig = {
    baseURL: Config.GLOBAL_API_ROOT,
};

const axios = Axios.create(baseConfig);

// 请求拦截器，自动加token
axios.interceptors.request.use((config) => {
    // 优先从store获取token，如果没有则从localStorage获取
    let token = null;
    
    // 尝试从store获取token
    try {
        token = store.getters.accessToken;
    } catch (error) {
        console.warn('从store获取token失败:', error);
    }
    
    // 如果store中没有，则从localStorage获取
    if (!token) {
        token = localStorage.getItem('access_token');
    }
    
    
    if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;
    } else {
        console.warn('未找到access_token，请求将不携带认证信息');
    }
    
    return config;
}, (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
});

axios.interceptors.response.use((value: AxiosResponse) => {
    return value;
}, (error: any) => {
    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
        console.warn('Token已过期或无效，清除用户信息');
        // 清除用户信息
        try {
            store.commit('clearUserInfo');
        } catch (error) {
            console.warn('清除store用户信息失败:', error);
            // 如果store不可用，直接清除localStorage
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('clientInfo');
        }
        
        // 可以在这里添加重定向到登录页的逻辑
        // window.location.href = '/';
    }
    
    return Promise.reject(error);
});

export default axios;

const resHandle = (VueComponent: any, data: any, loading?: any) => {
    return new Promise((resolve, reject) => {
        resolve(data);
        // if (data.error_code === 0) {
        //     if (loading) {
        //         loading.close();
        //     }
        //     resolve(data);
        // } else {
        //     import('vant').then(({ Toast }) => {
        //         Toast.fail({
        //             message: data.msg,
        //             duration: 2000
        //         });
        //     });
        //     if (loading) {
        //         loading.close();
        //     }
        //     reject(data.msg);
        // }
    });
};

export { resHandle };
